// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ActivityOperatorSchema = z.enum(['AGENT','SYSTEM'] as const);

export type ActivityOperatorType = `${z.infer<typeof ActivityOperatorSchema>}`

export default ActivityOperatorSchema;
